import React from 'react';
import Spotlight3Images from '../../components/Spotlight3Images/Spotlight3Images';
import './Spotlight3.scss';
import Spotlight3Details from '../../components/Spotlight3Details/Spotlight3Details';
import Spotlight3Featured from '../../components/Spotlight3Featured/Spotlight3Featured';
import Spotlight3ConnectWallet from '../../components/Spotlight3ConnectWallet';

function Spotlight3() {
  return (
    <main className="sptlght3__main">
      <div className="sptlght3__connect-display-button sptlght3__connect-display-button--mobile">
        <Spotlight3ConnectWallet />
      </div>
      <Spotlight3Featured />
      <div className="sptlght3__desktop-container">
        <Spotlight3Images />
        <Spotlight3Details />
      </div>
    </main>
  );
}

export default Spotlight3;
